import { getSinglarOrPluralWord } from "../../utilities/helpers";

import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";

export default function SelectedTickets({
  selected,
  showRemoveSeat,
  onRemoveSeat,
}) {
  return (
    <>
      <div className="list-item list-item-lg list-item-lg--sm list-item--primary gap-4">
        <Stack direction="vertical">
          <span className="text-muted normal">Selected:</span>
          <Stack direction="vertical">
            {selected &&
              selected.map((group, i) => {
                return (
                  <SelectedRow
                    key={i}
                    group={group}
                    showRemoveSeat={showRemoveSeat}
                    onRemoveSeat={onRemoveSeat}
                  />
                );
              })}
          </Stack>
        </Stack>
      </div>
    </>
  );
}

function SelectedRow({ group, showRemoveSeat, onRemoveSeat }) {
  if (group.generalAdmission) {
    return (
      <span className="normal normal-bold">
        {group?.sectionNumber} •{" "}
        {group?.generalAdmission
          ? `${group?.ticketCount} ${getSinglarOrPluralWord(group?.ticketCount)}`
          : group.seats}
      </span>
    );
  }

  const canRemove =
    showRemoveSeat &&
    onRemoveSeat &&
    Array.isArray(group.tickets) &&
    group.tickets.length > 0;

  if (canRemove) {
    return (
      <Stack direction="vertical" gap={2} className="selected-seats-list">
        {group.tickets.map((ticket, idx) => {
          const seatNum = ticket.seatNumber ?? ticket.seat_number;
          return (
            <Stack
              key={ticket.id ?? idx}
              direction="horizontal"
              gap={3}
              className="selected-seat-row align-items-center py-1"
            >
              <span className="normal normal-bold selected-seat-label">
                Sec {group?.sectionNumber} • Row {group?.rowNumber} • Seat{" "}
                {seatNum}
              </span>
              <Button
                variant="outline-danger"
                size="sm"
                className="selected-seat-remove-btn flex-shrink-0"
                onClick={() =>
                  onRemoveSeat(group.sectionNumber, group.rowNumber, seatNum)
                }
                aria-label={`Remove seat ${group.sectionNumber} ${group.rowNumber} ${seatNum}`}
              >
                Remove
              </Button>
            </Stack>
          );
        })}
      </Stack>
    );
  }

  return (
    <span className="normal normal-bold">
      Sec {group?.sectionNumber} • Row {group?.rowNumber} • Seat{" "}
      {group?.generalAdmission
        ? `${group?.ticketCount} ${getSinglarOrPluralWord(group?.ticketCount)}`
        : group.seats}
    </span>
  );
}
